import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import { Store, Mail, Phone, MapPin, Heart } from 'lucide-react';

const StoreFooter = () => {
  const { isDarkMode } = useTheme();
  return (
    <footer className="bg-gray-900 text-gray-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="mb-4">
              {isDarkMode ? (
                <img src="/sttora.png" alt="STTORA" className="h-12" />
              ) : (
                <div className="inline-block p-2 bg-gray-800 rounded-xl">
                  <img src="/sttora.png" alt="STTORA" className="h-10" />
                </div>
              )}
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Cambiando vidas y haciendo historia. Tu tienda de confianza para productos de consumo masivo y más.
            </p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            <h3 className="text-white font-semibold mb-4">Categorías</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/store/categories/ofertas-semana" className="hover:text-orange-400 transition-colors">Ofertas</Link></li>
              <li><Link to="/store/categories/primera-necesidad" className="hover:text-orange-400 transition-colors">Primera Necesidad</Link></li>
              <li><Link to="/store/categories/higiene-cuidado-personal" className="hover:text-orange-400 transition-colors">Higiene Personal</Link></li>
              <li><Link to="/store/categories/tecnologia-gamer" className="hover:text-orange-400 transition-colors">Tecnología</Link></li>
            </ul>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <h3 className="text-white font-semibold mb-4">Enlaces</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/store" className="hover:text-orange-400 transition-colors">Inicio</Link></li>
              <li><Link to="/store/featured" className="hover:text-orange-400 transition-colors">Destacados</Link></li>
              <li><Link to="/login" className="hover:text-orange-400 transition-colors">Mi Cuenta</Link></li>
            </ul>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            <h3 className="text-white font-semibold mb-4">Contacto</h3>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-orange-400" /> info@sttora.com</li>
              <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-orange-400" /> +1 555-0123</li>
              <li className="flex items-center gap-2"><MapPin className="w-4 h-4 text-orange-400" /> STTORA Global HQ</li>
            </ul>
          </motion.div>
        </div>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-500"
        >
          <p>&copy; {new Date().getFullYear()} STTORA. Todos los derechos reservados.</p>
          <p className="mt-2 flex items-center justify-center gap-1">
            Hecho con <Heart className="w-3 h-3 text-red-500" /> por el equipo STTORA
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default StoreFooter;
